import { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { featuredProducts } from "@/mocks/products";
import PageSEO from "@/components/base/PageSEO";

const categories = ["全部商品","新品上市","熱銷推薦","上衣系列","洋裝系列","外套系列","褲裝系列","套裝系列","特價專區","最後出清"];

export default function Shop() {
  const [activeCategory, setActiveCategory] = useState("全部商品");
  const [sort, setSort] = useState("推薦");

  const allProducts = [
    ...featuredProducts,
    { id: 7, name: "法式優雅泡泡袖上衣", tagline: "浪漫細節，顯瘦有型", originalPrice: 3500, salePrice: 1880, image: "https://readdy.ai/api/search-image?query=elegant%20women%20puff%20sleeve%20blouse%20feminine%20romantic%20cream%20background%20taiwanese%20designer%20quality%20fabric%20mature%20style&width=400&height=560&seq=sp007&orientation=portrait", badge: "新品", category: "上衣系列" },
    { id: 8, name: "都會修身九分褲", tagline: "俐落顯高，通勤首選", originalPrice: 3800, salePrice: 1980, image: "https://readdy.ai/api/search-image?query=elegant%20women%20tailored%20cropped%20pants%20slim%20fit%20professional%20warm%20beige%20background%20taiwanese%20designer%20mature%20urban%20style%20quality&width=400&height=560&seq=sp008&orientation=portrait", badge: "熱銷", category: "褲裝系列" },
    { id: 9, name: "知性格紋長版外套", tagline: "層次穿搭，秋冬必備", originalPrice: 7200, salePrice: 3680, image: "https://readdy.ai/api/search-image?query=elegant%20women%20plaid%20long%20coat%20outerwear%20sophisticated%20mature%20cream%20background%20taiwanese%20designer%20quality%20autumn%20winter%20fashion&width=400&height=560&seq=sp009&orientation=portrait", badge: "Outlet", category: "外套系列" },
    { id: 10, name: "氣質荷葉邊洋裝", tagline: "優雅飄逸，適合各種場合", originalPrice: 4800, salePrice: 2480, image: "https://readdy.ai/api/search-image?query=elegant%20women%20ruffle%20hem%20midi%20dress%20feminine%20graceful%20worn%20by%20mature%20woman%20warm%20rose%20background%20taiwanese%20designer%20quality&width=400&height=560&seq=sp010&orientation=portrait", badge: "特價", category: "洋裝系列" },
  ];

  const filtered = activeCategory === "全部商品"
    ? allProducts
    : allProducts.filter(p => p.category === activeCategory || (activeCategory === "新品上市" && p.badge === "新品") || (activeCategory === "熱銷推薦" && p.badge === "熱銷") || (activeCategory === "特價專區" && (p.badge === "特價" || p.badge === "Outlet")));

  return (
    <div className="min-h-screen bg-[#faf8f5]">
      <PageSEO
        title="商品分類｜台中設計師女裝Outlet 洋裝套裝外套精選"
        description="瀏覽台中設計師女裝Outlet全系列商品，包含熟齡洋裝、修身套裝、優雅外套、褲裝上衣等，Outlet優惠價格入手高質感台灣設計師女裝。"
        keywords="台中女裝商品,設計師洋裝Outlet,熟齡套裝,修身外套,台灣女裝優惠"
        canonical="https://www.example.com/shop"
      />
      <Navbar />
      <main>
        {/* Header */}
        <section className="relative h-[40vh] min-h-[320px] overflow-hidden">
          <img src="https://readdy.ai/api/search-image?query=elegant%20women%20fashion%20clothing%20collection%20boutique%20display%20warm%20cream%20beige%20background%20designer%20brand%20quality%20minimalist%20luxury%20atmosphere&width=1400&height=600&seq=shop001&orientation=landscape" alt="商品分類" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/50" />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
            <p className="text-[#f5d8b8] text-[1rem] tracking-[0.3em] uppercase font-medium mb-3">Collections</p>
            <h1 className="text-white text-[2.75rem] md:text-[3.25rem] font-bold leading-[1.3] mb-3">商品分類</h1>
            <p className="text-white/80 text-[1.1875rem] max-w-lg leading-[1.75]">精選台灣設計師 30 年暢銷品牌，Outlet 優惠價格入手質感女裝</p>
          </div>
        </section>

        {/* Category Filter */}
        <section className="bg-white border-b border-[#ede8e0] sticky top-[72px] z-30">
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="flex items-center gap-2 py-4 overflow-x-auto scrollbar-hide">
              {categories.map(cat => (
                <button key={cat} onClick={() => setActiveCategory(cat)}
                  className={`px-5 py-2 rounded-full text-[1rem] font-medium transition-all duration-200 cursor-pointer whitespace-nowrap flex-shrink-0 ${activeCategory === cat ? "bg-[#3d2b1f] text-[#faf8f5]" : "bg-[#f5ede4] text-[#7a6455] hover:bg-[#e8d8c8]"}`}>
                  {cat}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Products Grid */}
        <section className="py-14 md:py-20" data-product-shop>
          <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
            <div className="flex items-center justify-between mb-8">
              <p className="text-[#7a6455] text-[1.0625rem]">共 <strong className="text-[#3d2b1f]">{filtered.length}</strong> 件商品</p>
              <select value={sort} onChange={e => setSort(e.target.value)}
                className="text-[1rem] border border-[#e0d4c8] rounded-md px-4 py-2 bg-white text-[#3d2b1f] cursor-pointer outline-none focus:border-[#8B5E52]">
                <option>推薦</option><option>價格低到高</option><option>價格高到低</option><option>最新上架</option>
              </select>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-5">
              {filtered.map(product => (
                <div key={product.id} className="group bg-white rounded-lg overflow-hidden cursor-pointer">
                  <Link to={`/product/${product.id}`} className="block">
                    <div className="relative aspect-[5/7] overflow-hidden">
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                      <span className={`absolute top-3 left-3 px-2.5 py-1 rounded text-[0.875rem] font-semibold ${product.badge === "新品" ? "bg-[#8B5E52] text-white" : product.badge === "熱銷" ? "bg-[#3d2b1f] text-[#f5e8d8]" : "bg-[#c9a98a] text-[#3d2b1f]"}`}>{product.badge}</span>
                      <div className="absolute inset-0 bg-[#3d2b1f]/50 flex flex-col items-center justify-center gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <span className="flex items-center gap-2 px-5 py-2.5 bg-white text-[#3d2b1f] rounded-full text-[0.9375rem] font-semibold whitespace-nowrap">查看商品詳情</span>
                      </div>
                    </div>
                  </Link>
                  <div className="p-4">
                    <p className="text-[#7a6455] text-[0.875rem] mb-1">{product.category}</p>
                    <Link to={`/product/${product.id}`}>
                      <h3 className="text-[#3d2b1f] text-[1.0625rem] font-semibold leading-[1.45] mb-1 hover:text-[#8B5E52] transition-colors">{product.name}</h3>
                    </Link>
                    <p className="text-[#8B5E52] text-[0.9375rem] mb-2">{product.tagline}</p>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <span className="text-[#8B5E52] text-[1.0625rem] font-bold">NT${product.salePrice.toLocaleString()}</span>
                        <span className="text-[#a09080] text-[0.875rem] line-through">NT${product.originalPrice.toLocaleString()}</span>
                      </div>
                      <a href="https://line.me" target="_blank" rel="noopener noreferrer" className="w-8 h-8 flex items-center justify-center bg-[#f5ede4] rounded-full text-[#8B5E52] hover:bg-[#8B5E52] hover:text-white transition-colors cursor-pointer" title="LINE 詢問">
                        <i className="ri-line-fill text-[1rem]"></i>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
